<template>
<div>
    <div>
         <div id="encabezados-tp">
            <h1>Consulta Audiencias</h1>
            <h3></h3>
            <!-- <div class="hr-titulo"></div> -->
        </div>
           <div class="filtros-busqueda">
               <select name="partido" id="Partido" class='form-control campos' v-model="PartidoJudicial" required>
                 <option value="0" selected>Todos</option>
                 <option v-for="(partido,index) in CATALOGOS.partidoJudicial" :key="index" :value="partido.llave">{{partido.valor}}</option>              
             </select>

             <input type="date" class='form-control campos' v-model="Fecha"/>
             <!-- </div> -->
             <button type="button" class="btn btn-info" @click="ObtenerAudiencias">Ir a Fecha</button>
           </div>
           <div class="reloj">
               {{hora}}
           </div>
        </div>

        <br><br>
    <div>
           <h6></h6>
           <table 
                class="table table-striped table-light table-hover letra-grande"
                id='tabla-audiencas'             
                data-toggle="table"
                data-undefined-text="-"  
                data-click-to-select="false"
                
           >
           <thead  class="thead-dark">
               <tr>
                   <!-- <th data-halign="center" data-width="6" data-align="center"  data-field="audiencia_id">FOLIO</th> -->
                   <th data-halign="center" data-align="center"  data-field="NombrePartido">MUNICIPIO</th>
                   <th data-halign="center" data-align="center"  data-field="ConDetenido">DETENIDO</th>
                   <th data-halign="center" data-align="center"  data-field="FechaDeAudiencia">FECHA DE AUDIENCIA</th>
                   <th data-halign="center" data-align="center"  data-field="HoraDeAudiencia">HORA</th>
                   <th data-halign="center" data-align="center"  data-field="carpeta_alias">CARPETA</th>                
                   <th data-halign="center" data-align="center"  data-field="Sala">SALA</th>
                   <th data-halign="center" data-align="center"  data-field="zoom_id">ID ZOOM</th>
                   <th data-halign="center" data-align="center"  data-field="audiencia_tipo">AUDIENCIA</th>
                   <th data-halign="center" data-align="center"  data-field="audiencia_auxiliar">AUXILIAR</th>
                   <th data-halign="center" data-align="center"  data-field="audiencia_1_juez">JUEZ</th>
                   <th data-halign="center" data-align="center"  data-field="audiencia_status">ESTADO</th>
               </tr>
           </thead>

           </table>
       </div>

</div>
</template>


<script>
import axios from 'axios';
import api from '@/../static/js/api'
import {CATALOGOS} from '../Catalogos/CatalogosBD.js'
import moment from 'moment'

export default{
    data(){
            return{
                CATALOGOS,
                Fecha:moment().format('YYYY-MM-DD'),
                partidos:[{id:1,Nombre:"Aguascalientes"},{id:2,Nombre:"Calvillo"},{id:3,Nombre:"Pabellón de Arteaga"},{id:4,Nombre:"Rincón de Romos"},{id:5,Nombre:"Jesús María"},{id:6,Nombre:"Adolescentes"}],
                PartidoJudicial:0,
                hora:null,

            }
        },
    methods:{
        ObtenerAudiencias: async function(){
        //  clearInterval();
           
            let parametros = {
                Fecha:  this.Fecha,
                PartidoJudicial:this.PartidoJudicial
            }
            const RESPUESTA = await axios.post(api.conexion+'Audiencias/AgendaControlAux/AgendaControlAuxInformatica',parametros,null);
         

            //return await RESPUESTA;
              let Datos = await this.formatoAudienciasJuez(await RESPUESTA.data.Audiencias);
            $("#tabla-audiencas").bootstrapTable({data:await Datos.filter(a=>a.audiencia_status !="Concluida" && a.audiencia_show==1 )});
            $("#tabla-audiencas").bootstrapTable("load",await Datos.filter(a=>a.audiencia_status !="Concluida" && a.audiencia_show==1 ));
            //  console.log("fin del metodo::",await Datos)

             
        
      //  await setInterval(this.ObtenerAudiencias,8000)
        
        },
        // ObtenerAudienciasPorGrupo:async function(){
         
        //    let Respuesta = await this.ObtenerAudiencias
            
        // },
        formatoAudienciasJuez:async function(doc){
            let documento
            documento = doc.map(c => {
                let docFormateado = c;
                var NombrePartido =CATALOGOS.partidoJudicial.filter(a=>a.llave==c.partido_id);
                docFormateado.Sala = (c.audiencia_sala!=null)?c.audiencia_sala+" "+c.audiencia_modo : "-";
                docFormateado.FechaDeAudiencia = (c.audiencia_fecha!=null)?moment(c.audiencia_fecha,"YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY"):"-"; 
                docFormateado.HoraDeAudiencia = (c.audiencia_fecha!=null)?moment(c.audiencia_fecha,"YYYY-MM-DD HH:mm:ss").format("HH:mm"):"-";
                docFormateado.NombrePartido = NombrePartido[0].valor;
                docFormateado.FechaAgendada = (c.audiencia_registrada!=null)?moment(c.audiencia_registrada,"YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY"):"-";
                docFormateado.ConDetenido = (c.audiencia_detenido == 1)?"Si":"No";
                return docFormateado;
            });
            return documento;
        },
      

 Reloj:function () {
     var today = new Date();
     var hr = today.getHours();
     var min = today.getMinutes();
     var sec = today.getSeconds();
     //Add a zero in front of numbers<10
     min = this.checkTime(min);
     sec = this.checkTime(sec);   
     this.hora =  hr + " : " + min + " : " + sec;
    
 },
 checkTime:function(i)  {
     if (i < 10) {
         i = "0" + i;
     }
     return i;
 },

        
        
    },
    mounted(){
      // setTimeout(()=>{ this.Reloj() }, 500);
    
setInterval(()=>{ this.Reloj() }, 1000);
setInterval(async ()=>{ await this.ObtenerAudiencias() }, 100000);
      
//this.ObtenerAudienciasPorGrupo();
//  setInterval(() => {
//      console.log("ejecuta::")
//    this.ObtenerAudiencias();
//  }, (1000 * 60));
  
	
 
    },
     created(){
        
    }
}


</script>
<style scoped>
.letra-grande{
    font-size: 1.2em;
    font-weight: bold;
    font-family:'Open Sans', sans-serif;
}
.reloj{
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    margin-right: .5em;
    font-weight: bold;
    font-size: 6em;

}
.campos{
    width: 20%;
}
#encabezados-tp {
    margin-bottom: 4em;
    width: 100%;
    text-align: center;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 2.5em;
}

#encabezados-tp h3 {
    font-size: 1.5em;
    color: rgb(175, 175, 175);
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}
.filtros-busqueda {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1em;
    flex-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/Audiencias/VistaMonitor/VistaMonitorEstatica.vue